import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import {
  IProgramTypeCreatePayload,
  IProgramTypeRequestPayload,
  IProgramTypeResponsePayload,
  IProgramTypeUpdatePayload,
  IProgramTypeWriteResponsePayload,
} from 'shared/interfaces/IProgramType';
import { transformPayload } from 'shared/utils/transformPayload';

export const useProgramTypeDao = () => {
  const { GET, POST, DELETE } = useAxios();

  const getProgramTypes = async (payload?: IProgramTypeRequestPayload) => {
    const transformedPayload = transformPayload<IProgramTypeRequestPayload>(payload);

    const response = await GET<IProgramTypeResponsePayload>({
      url: ENDPOINTS.PROGRAM_TYPE,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  const createProgramType = async (payload: IProgramTypeCreatePayload) => {
    const formData = new FormData();
    formData.append('token', transformPayload<IProgramTypeCreatePayload>(payload));

    const response = await POST<IProgramTypeWriteResponsePayload>({
      url: `${ENDPOINTS.PROGRAM_TYPE}/create`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  const updateProgramType = async (payload: IProgramTypeUpdatePayload) => {
    const formData = new FormData();
    formData.append('token', transformPayload<IProgramTypeUpdatePayload>(payload));

    const response = await POST<IProgramTypeWriteResponsePayload>({
      url: `${ENDPOINTS.PROGRAM_TYPE}/update`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  const deleteProgramType = async (id: string) => {
    const response = await DELETE({
      url: `${ENDPOINTS.PROGRAM_TYPE}/delete`,
      params: {
        token: transformPayload({ _id: id }),
      },
    });

    return response.data as IProgramTypeWriteResponsePayload;
  };

  return {
    getProgramTypes,
    createProgramType,
    updateProgramType,
    deleteProgramType,
  };
};
